module.exports = __webpack_public_path__ + "inputs/img/banner1.7c4fe1a1.png";